import React from "react";
import "../../styles/Accordion.css"
import AllertIscrizione from "../multitessere/AllertIscrizione";
import AllertCertificato from "../multitessere/AllertCertificato";

function NLAccordionPrezzi() {
    return (
        <div className="accordion d-flex flex-column m-auto" id="accordionFlushExample" style={{maxWidth: "45em"}}>
            <div className="accordion-item">
                <h2 className="accordion-header d-flex flex-row" id="headingOne"
                    style={{justifyContent: "center", textAlign: "center"}}>
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                        PREZZI
                    </button>
                </h2>
                <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne"
                     data-bs-parent="#accordionFlushExample">
                    <div className="accordion-body">
                        <div className="table-container">
                            <table className="table text-center m-auto" style={{minWidth: "30em"}}>
                                <thead >
                                <tr >
                                    <th scope="col" ></th>
                                    <th scope="col" style={{width: "15%"}}>
                                        1 mese
                                    </th>
                                    <th scope="col" style={{width: "15%"}}>
                                        3 mesi
                                    </th>
                                    <th scope="col" style={{width: "15%"}}>
                                        6 mesi
                                    </th>
                                    <th scope="col" style={{width: "15%"}}>
                                        11 mesi
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr style={{backgroundColor: "#F8F8F8"}}>
                                    <th scope="row">Orario pieno</th>
                                    <td className={"data-cell"}>130€</td>
                                    <td className={"data-cell"}>300€</td>
                                    <td className={"data-cell"}>500€</td>
                                    <td className={"data-cell"}>760€</td>
                                </tr>
                                <tr>
                                    <th scope="row">Orario ridotto <br/> <span style={{fontSize: "12px"}}>(fino alle 16)</span></th>
                                    <td className={"data-cell"}>100€</td>
                                    <td className={"data-cell"}>250€</td>
                                    <td className={"data-cell"}>450€</td>
                                    <td className={"data-cell"}>600€</td>
                                </tr>
                                </tbody>
                            </table>
                           <br/>
                            <br/>
                        </div>
                        <div className="table-container">
                            <table className="table text-center m-auto" style={{width: "20em"}}>
                                <thead >
                                <tr >
                                    <th scope="col" ></th>
                                    <th scope="col" style={{width: "30%"}}>
                                        Singolo
                                    </th>
                                    <th scope="col" style={{width: "30%"}}>
                                        11 ingressi
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr style={{backgroundColor: "#F8F8F8"}}>
                                    <th scope="row">Ingressi</th>
                                    <td className={"data-cell"}>15€</td>
                                    <td className={"data-cell"}>130€</td>
                                </tr>
                                </tbody>
                            </table>
                            <br/>
                            <AllertIscrizione />
                            <br/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NLAccordionPrezzi